<template>
  <v-container fluid class="pa-0 ma-0">
    <b style="width: 100%" v-if="widget.data.title!==''">{{ widget.data.title }}</b>
    <v-form
      v-if="widget.type==='form'"
      :name=widget.data.id
      :ref=widget.data.id
      :id="widget.data.id"
      v-model="widget.data.valid"
      @submit.prevent="submit(widget.data.id)"
      style="padding: 15px"
    >
      <v-row>
        <template v-for="field in widget.data.elements">
          <v-col
            :cols="field.size.small"
            :sm="field.size.small"
            :md="field.size.medium"
            :lg="field.size.larg"
            :xl="field.size.xlarg"
            :offset-xl="field.size.xlOffset"
            :offset-lg="field.size.lgOffset"
            :offset-sm="field.size.smOffset"
            :offset-md="field.size.mdOffset"
            v-if="field.model!=='By By Model Sorry for Removing you' && !(field.type==='submit' && widget.data.autoSubmit===true)"
            :style="field.size.customStyle"
          >
            <span style="width: 100%" v-if="field.label!==''">
              <span style="color:transparent !important" v-if="field.label==='.'">
                {{ field.label }}
              </span>
              <span style="font-size: 11px !important;"
                    v-else>{{ field.label }}
              </span>
            </span>
            <tile-icon-left-default-design :widget="field"
                                           v-if="field.type==='tile' && field.data.template==='defaultIconLeftDesign'"/>
            <tile-default-design :widget="field"
                                 v-if="field.type==='tile' && field.data.template==='defaultDesign'"/>
            <full-dynamic-html v-if="field.type==='htmlContent'" :widget="field"/>
            <tile-btn-design :widget="field"
                             v-if="field.type==='tile' && field.data.template==='btnDesign'"/>
            <v-text-field :readonly="widget.data.action==='' || field.readOnly===true"
                          :label="field.title"
                          :disabled="widget.data.action==='' || field.readOnly===true"
                          :prefix="field.prefix"
                          :suffix="field.suffix"
                          v-if="field.numberFormat === true && field.readOnly!==true"
                          :value="field.model"
                          @input="$event => field.model = Intl.NumberFormat().format($event.replaceAll(',', ''))"

                          autocomplete="off"
                          :autofocus="field.focus===true"
                          :rules="field.rules"
                          @keydown="(e)=>{e.key==='Enter' ? autoSubmit(widget.data.id) : null}"
            ></v-text-field>
            <!-- inja ro pichoondam -->
            <v-text-field :readonly="widget.data.action==='' || field.readOnly===true"
                          :label="field.title"
                          :disabled="widget.data.action==='' || field.readOnly===true"
                          :prefix="field.prefix"
                          :suffix="field.suffix"
                          v-if="field.numberFormat === true && field.readOnly===true"
                          :value="field.numberFormat=== true ?  field.model!=='' ? field.numberFormatValue=Intl.NumberFormat().format(parseInt(field.model)) : field.model: field.model"
                          @input="($event)=>{field.model=$event}"
                          autocomplete="off"
                          :autofocus="field.focus===true"
                          :rules="field.rules"
                          @keydown="(e)=>{e.key==='Enter' ? autoSubmit(widget.data.id) : null}"
            ></v-text-field>
            <v-text-field :prefix="field.prefix" :suffix="field.suffix"
                          @input="($event)=>{if(field.numberFormat === true){ field.numberFormatValue=Intl.NumberFormat().format(parseInt($event)) }else{field.model='' ; field.model = $event} }"
                          autocomplete="off"
                          :autofocus="field.focus===true"
                          v-if="field.type==='text' && field.model!=='By By Model Sorry for Removing you' && field.maskName==='' && field.numberFormat === false"
                          :value="field.numberFormat=== true ?  field.model!=='' ? field.numberFormatValue=Intl.NumberFormat().format(parseInt(field.model)) : field.model: field.model"
                          :readonly="widget.data.action==='' || field.readOnly===true"
                          :disabled="widget.data.action==='' || field.readOnly===true"
                          @keyup="(event) => {
             if (field.numberFormat===true){
                let v= event.target.value.toString().replace(/,/g,'');
                field.numberFormatValue =  Intl.NumberFormat().format(parseInt(v))
                field.model=v
              }else{
               let v = event.target.value.toString();
                field.model=v
              }
            }"
                          :color="widget.data.action==='' ? 'black' : 'primary'"
                          :label="field.title"
                          :rules="field.name==='national_code' ? [v => checkNationalCode(v)] || 'لطفا کد ملی را صحیح وارد نمایید.' :field.rules"
                          @keydown="(e)=>{e.key==='Enter' ? autoSubmit(widget.data.id) : null}"
                          required

            ></v-text-field>
            <div style="width: 50% ; float: right ; padding-left: 10px">
              <v-text-field :prefix="field.prefix" :suffix="field.suffix"
                            v-model="field.model"
                            autocomplete="off"
                            v-if="field.type==='password' && field.model!=='By By Model Sorry for Removing you'"
                            :label="field.title"
                            :rules="field.rules"
                            type="password"
                            required

              ></v-text-field>
            </div>
            <div style="width: 50% ; float: right; padding-right: 10px">
              <v-text-field :prefix="field.prefix" :suffix="field.suffix"
                            autocomplete="off"
                            v-if="field.type==='password' && field.model!=='By By Model Sorry for Removing you'"
                            :label="'تکرار ' + field.title"
                            :rules="[v => !!v || 'لطفا تکرار رمز عبور خود را وارد نمایید.', v => (v && v === field.model) || 'در تکرار رمز عبور دچار اشتباه شده اید.']"
                            type="password"
                            required

              ></v-text-field>
            </div>
            <v-text-field
              :prefix="field.prefix"
              :suffix="field.suffix"
              @input="($event)=>{field.model=$event}"
              v-mask="field.maskName==='phone' ? '09##'+ field.strMask +'###'+ field.strMask +'####' : field.maskName==='number' ? '#'.repeat(field.maskLenght) : field.maskName==='tell' ? '0##'+ field.strMask +'####'+ field.strMask +'####' : field.maskName==='english' ? 'S'.repeat(field.maskLenght) : field.maskName==='englishNumber' ? 'X'.repeat(field.maskLenght) : field.maskName==='iban' ? 'IR########################': ''"
              autocomplete="off"
              :autofocus="field.focus===true"
              :class="field.maskName==='phone' ? 'phoneThings' : field.maskName==='tell' ? 'phoneThings' :''"
              v-if="field.type==='text' && field.model!=='By By Model Sorry for Removing you' && field.maskName!==''"
              :value="field.numberFormat=== true ?  field.model!=='' ? field.numberFormatValue=Intl.NumberFormat().format(parseInt(field.model)) : field.model: field.model"
              :readonly="widget.data.action==='' || field.readOnly===true"
              :disabled="widget.data.action==='' || field.readOnly===true"
              @keyup="(event) => {
             if (field.numberFormat===true){
                let v= event.target.value.toString().replace(/,/g,'');
                field.numberFormatValue =  Intl.NumberFormat().format(parseInt(v))
                field.model=v
              }else{
               let v = event.target.value.toString();
                field.model=v
              }
            }"
              :color="widget.data.action==='' ? 'black' : 'primary'"
              :label="field.title"
              :rules="field.name==='national_code' ? [v => checkNationalCode(v) || 'لطفا کد ملی را صحیح وارد نمایید.']: field.rules"
              @keydown="(e)=>{e.key==='Enter' ? autoSubmit(widget.data.id) : null}"
              required
            ></v-text-field>
            <v-text-field
              v-if="field.type==='hidden'"
              v-show="false"
              v-model="field.model"
              :label="field.title"
              :rules="field.rules"
              required
            ></v-text-field>
            <v-select
              v-if="field.type==='dropdown' && field.searchable===false && field.model!=='By By Model Sorry for Removing you'"
              v-model="field.model"
              :items="field.options"
              :label="field.title"
              :readonly="widget.data.action==='' || field.readOnly===true"
              :disabled="widget.data.action==='' || field.readOnly===true"
              item-text="text"
              item-value="value"
              required
              :rules="field.rules"
              @change="change(field.onChange,field.model,widget.data.id)"
            ></v-select>
            <v-combobox
              v-if="field.type==='dropdown' && field.searchable===true && field.model!=='By By Model Sorry for Removing you'"
              v-model="field.model"
              :items="field.options"
              :label="field.title"
              :readonly="widget.data.action==='' || field.readOnly===true"
              :disabled="widget.data.action==='' || field.readOnly===true"
              item-text="text"
              item-value="value"
              required
              :rules="field.rules"
              @change="change(field.onChange,field.model,widget.data.id)"
            ></v-combobox>
            <h2
              v-if="field.type==='radiobutton' && field.model!=='By By Model Sorry for Removing you'"
              class="h2"
            >
              {{ field.title }}
            </h2>
            <v-radio-group
              row
              v-if="field.type==='radiobutton' && field.model!=='By By Model Sorry for Removing you'"
              v-model="field.model"
              class="display:inline"
              @change="autoSubmit(widget.data.id)"
              required
            >
              <v-radio
                v-for="item in field.options"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              ></v-radio>
            </v-radio-group>

            <div style="display: flex; flex-direction: row" class="mt-4"
                 v-if="field.type==='chipsbutton' && field.model!=='By By Model Sorry for Removing you'">
              <div style="width: fit-content ;font-size: 16px ; color: black "> {{
                  field.title
                }}
              </div>
              <div style="flex: 1">
                <v-chip-group
                  :class="field.bigChips!=='' ? 'mt-n5' : 'mt-n3'"
                  row
                  v-model="field.model"
                  @change="change(field.onChange,field.model,widget.data.id)"
                  required
                  :active-class="field.backgroundColor"
                  column
                >
                  <v-chip
                    :class="'deActive'+field.backgroundColor + field.bigChips"
                    filter
                    v-for="item in field.options"
                    :key="item.value"
                    @click="()=>{field.model=item.value}"
                    :value="item.value"
                  >
                    {{ item.text }}
                  </v-chip>
                </v-chip-group>
              </div>
            </div>


            <template
              v-if="field.type==='checkbox' && field.model!=='By By Model Sorry for Removing you'">
              <v-row>
                <v-col cols="12" v-if="field.title!==''">
                  <h2
                    v-if="field.type==='checkbox' && field.model!=='By By Model Sorry for Removing you'"
                    class="h2"
                  >
                    {{ field.title }}
                  </h2>
                </v-col>
                <v-col
                  v-for="item in field.options"
                  :key="item.value+item.text"
                >
                  <v-checkbox
                    :key="item.value+item.text"
                    v-model="field.model"
                    :value="item.value"
                    false-value=""
                    true-value="1"
                    @change="change(field.onChange,field.model,widget.data.id)"
                  >
                    <template v-slot:label>
                      <div v-html="item.text" style="text-align: right"></div>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>
            </template>

            <v-file-input
              v-if="(field.type==='image'  || field.type==='file')  && field.model!=='By By Model Sorry for Removing you'"
              v-model="field.model"
              :accept="field.accept"
              show-size
              :label="field.title"
              chips
              :multiple="field.isMultipleFile"
              @change="createImage(field.model)"
            ></v-file-input>
            <v-img
              v-if="field.type==='image' && field.model!=='By By Model Sorry for Removing you'"
              :src="imageFormUrl"
              width="50"
              height="50"
            />

            <v-textarea
              v-if="field.type==='textarea' && field.model!=='By By Model Sorry for Removing you'"
              v-model="field.model"
              @paste="(event)=>{
                field.model = onPaste(event)
                checkSubmitShouldBeActive(event,widget.data.id)
              }"
              outlined
              :label="field.title"
              required
            ></v-textarea>
            <iran-car-plaque v-if="field.type==='iranCarPlaque' && field.model!=='By By Model Sorry for Removing you'" v-model="field.model"/>
            <editor
              v-if="field.type==='ckEditor' && field.model!=='By By Model Sorry for Removing you'"
              v-model="field.model"
              api-key="ugjt1vxa8ftkebhke6nxyrdncj017909qzc2fgf8d28tluqj"
              :init="editorConfig"
            />

            <div style="width: 100% ; float: left ; text-align: left ; padding-top: 11px"
                 v-if="field.type==='submit'">
              <v-btn
                v-if="field.type==='submit' && (widget.data.updateId===0 || typeof widget.data.updateId==='undefined') && widget.data.autoSubmit===false"
                :loading="field.loading"
                :color="field.backgroundColor"
                :style="field.topIcon ? 'height:100px !important;color:' + field.foregroundColor : 'color:' + field.foregroundColor"
                :disabled="widget.data.valid!==true ? false : false"
                type="submit"
                :class="field.fullWidth ? 'w-full' : 'mr-4'"
                :x-large="field.topIcon ? 'x-large' : null"
                :tile="field.tile"
                @click="()=>{
                field.loading=true
                widget.data.field=field
                if (typeof field.action!=='undefined')
                {
                  if (typeof widget.data.oldAction==='undefined')
                    widget.data.oldAction=widget.data.action
                  if (typeof field.dialog!=='undefined'){
                    widget.data.action={dialog:field.dialog , action:field.action,destinationForm:field.destinationForm}
                  }
                  else
                    widget.data.action=field.action
                }else if(typeof field.dialog!=='undefined'){
                   field.loading=false
                  if (typeof widget.data.oldAction==='undefined')
                    widget.data.oldAction=widget.data.action
                  widget.data.action={dialog:field.dialog,destinationForm:field.destinationForm}
                }else {
                  if (typeof widget.data.oldAction!=='undefined')
                  widget.data.action = widget.data.oldAction
                }
              }"
              >
            <span
              :style="field.topIcon ? 'display: flex;flex-direction: column-reverse ; align-items:center ; justify-content : center' : ''">
            {{ field.title }}


            <v-icon :right="field.topIcon ? null : 'right'" v-if="typeof field.icon!=='undefined'"
                    :large="field.topIcon? 'large':null">
              {{ generateIcon(field.icon) }}
            </v-icon>
          </span>
              </v-btn>
              <v-btn
                v-if="field.type==='submit' && (widget.data.updateId!==0 && typeof widget.data.updateId!=='undefined') && widget.data.autoSubmit===false"
                :loading="field.loading"
                color="success"
                :disabled="widget.data.valid!==true ? false : false"
                type="submit"
                class="mr-4"
                @click="()=>{
                if (typeof field.action!=='undefined')
                {
                  field.loading=true
                  widget.data.buttonName=field.name
                  if (typeof widget.data.oldAction==='undefined')
                    widget.data.oldAction=widget.data.action
                  if (typeof field.dialog!=='undefined'){
                    widget.data.action={dialog:field.dialog , action:field.action,destinationForm:field.destinationForm}
                  }
                  else
                    widget.data.action=field.action
                }else if(typeof field.dialog!=='undefined'){
                   field.loading=false
                  if (typeof widget.data.oldAction==='undefined')
                    widget.data.oldAction=widget.data.action
                  widget.data.action={dialog:field.dialog,destinationForm:field.destinationForm}
                }else {
                  if (typeof widget.data.oldAction!=='undefined')
                  widget.data.action = widget.data.oldAction
                }
              }"
              >
                {{ field.titleOnUpdate }}
              </v-btn>
              <v-btn
                v-if="field.type==='submit' && (widget.data.updateId!==0 && typeof widget.data.updateId!=='undefined') && widget.data.autoSubmit===false"
                color="error"
                class="mr-4"
                @click="CancelUpdateFormView(widget.data.id)"
              >
                لغو
              </v-btn>
            </div>


            <!--image submit start -->
            <div style="width: 100% ; float: left ; text-align: left ; padding-top: 11px;"
                 v-if="field.type==='imageSubmit'">
              <v-img
                v-ripple
                contain
                :style="'cursor: pointer ;box-shadow: gray 0px 0px 6px; border-radius: 20px;' + field.customStyle"
                :width="field.width"
                :src="imageBaseUrl+field.image"
                v-if="field.type==='imageSubmit' && (widget.data.updateId===0 || typeof widget.data.updateId==='undefined') && widget.data.autoSubmit===false"
                :loading="field.loading"
                :class="field.fullWidth ? 'w-full' : 'mr-4'"
                @click="()=>{
                field.loading=true
                widget.data.field=field
                if (typeof field.action!=='undefined')
                {
                  if (typeof widget.data.oldAction==='undefined')
                    widget.data.oldAction=widget.data.action
                  if (typeof field.dialog!=='undefined'){
                    widget.data.action={dialog:field.dialog , action:field.action,destinationForm:field.destinationForm}
                  }
                  else
                    widget.data.action=field.action
                }else if(typeof field.dialog!=='undefined'){
                   field.loading=false
                  if (typeof widget.data.oldAction==='undefined')
                    widget.data.oldAction=widget.data.action
                  widget.data.action={dialog:field.dialog,destinationForm:field.destinationForm}
                }else {
                  if (typeof widget.data.oldAction!=='undefined')
                  widget.data.action = widget.data.oldAction
                }

                submit(widget.data.id)
              }"
              >
              </v-img>
              <v-btn
                v-if="field.type==='submit' && (widget.data.updateId!==0 && typeof widget.data.updateId!=='undefined') && widget.data.autoSubmit===false"
                :loading="field.loading"
                color="success"
                :disabled="widget.data.valid!==true ? false : false"
                type="submit"
                class="mr-4"
                @click="()=>{
                if (typeof field.action!=='undefined')
                {
                  field.loading=true
                  widget.data.buttonName=field.name
                  if (typeof widget.data.oldAction==='undefined')
                    widget.data.oldAction=widget.data.action
                  if (typeof field.dialog!=='undefined'){
                    widget.data.action={dialog:field.dialog , action:field.action,destinationForm:field.destinationForm}
                  }
                  else
                    widget.data.action=field.action
                }else if(typeof field.dialog!=='undefined'){
                   field.loading=false
                  if (typeof widget.data.oldAction==='undefined')
                    widget.data.oldAction=widget.data.action
                  widget.data.action={dialog:field.dialog,destinationForm:field.destinationForm}
                }else {
                  if (typeof widget.data.oldAction!=='undefined')
                  widget.data.action = widget.data.oldAction
                }
              }"
              >
                {{ field.titleOnUpdate }}
              </v-btn>
              <v-btn
                v-if="field.type==='submit' && (widget.data.updateId!==0 && typeof widget.data.updateId!=='undefined') && widget.data.autoSubmit===false"
                color="error"
                class="mr-4"
                @click="CancelUpdateFormView(widget.data.id)"
              >
                لغو
              </v-btn>
            </div>
            <!-- end image submit-->

            <date-picker
              :label="field.title"
              v-if="field.type==='date'"
              v-model="field.model"
              :disabled="field.readOnly===true"
              class="mt-3 float-right w-full"
              style="width: 100% "
              @change="()=>{autoSubmit(widget.data.id)}"
            />
            <date-picker
              :label="field.title"
              v-if="field.type==='time'"
              v-model="field.model"
              type="time"
            />
          </v-col>
        </template>
      </v-row>
      <v-row v-if="widget.data.hasProgressBar===true">
        <v-col>
          <v-progress-linear
            :color="this.status"
            v-model="this.model"
          ></v-progress-linear>
        </v-col>
      </v-row>
    </v-form>
    <dialog-validation :response="validationResponse"></dialog-validation>
    <div id="node-id"></div>
  </v-container>

</template>

<script>
import moment from "jalali-moment";
import axios from "@axios";
import baseConfig from '@/../baseConfig'
import router from "@/router";
import store from "@/store";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import Editor from "@tinymce/tinymce-vue";
import TileDefaultDesign from "@/views/generator/vueContents/tile/tile-default-design";
import TileIconLeftDefaultDesign
  from "@/views/generator/vueContents/tile/tile-icon-left-default-design";
import FullDynamicHtml from "@/views/generator/htmlContents/full-dynamic-html";
import {Money, VMoney} from 'v-money'
import {
  mdiCheck,
  mdiCheckCircleOutline,
  mdiCreditCard,
  mdiCreditCardCheck,
  mdiEyeOutline,
  mdiMenuLeftOutline,
  mdiMenuRightOutline,
  mdiMinusCircleOutline,
  mdiPen,
  mdiPlus,
  mdiTrashCan
} from "@mdi/js";
import {isEmpty} from "@core/utils";
import DialogValidation from "@/views/generator/dialogs/dialog-validation";
import {mask} from 'vue-the-mask'
import {formConfig, removeCharFromString} from "@/views/generator/page-handler";
import TileBtnDesign from "@/views/generator/vueContents/tile/tile-btn-design";
import IranCarPlaque from "@/views/generator/forms/iran-car-plaque.vue";

export default {
  directives: {money: VMoney, mask},
  name: "full-dynamic-form",
  components: {
    IranCarPlaque,
    Money,
    TileBtnDesign,
    DialogValidation,
    FullDynamicHtml,
    TileIconLeftDefaultDesign,
    TileDefaultDesign,
    datePicker: VuePersianDatetimePicker,
    editor: Editor,
  },
  props: {
    widget: Object,
    widgets: Array,
    filter: Object,
    paramId: String,
    requestApiUrl: String
  },
  data() {
    return {
      test : "25و62627",
      filteredModelForExcel: [],
      validationResponse: {
        status: false
      },
      mdiCheck: mdiCheck,
      imageBaseUrl: baseConfig.basUrlRaw,
      mdiCheckCircleOutline: mdiCheckCircleOutline,
      mdiCreditCard: mdiCreditCard,
      mdiCreditCardCheck: mdiCreditCardCheck,
      mdiEyeOutline: mdiEyeOutline,
      mdiMenuLeftOutline: mdiMenuLeftOutline,
      mdiMenuRightOutline: mdiMenuRightOutline,
      mdiMinusCircleOutline: mdiMinusCircleOutline,
      mdiPen: mdiPen,
      mdiPlus: mdiPlus,
      mdiTrashCan: mdiTrashCan,
      model: '0',
      modelCount: 0,
      modelTotal: 0,
      status: 'primary',
      imageFormUrl: '',
      editorConfig: {
        directionality: "rtl",
        automatic_uploads: true,
        images_upload_url: `${baseConfig.baseUrl}ticket/temp/image`,
        selector: 'textarea#full-featured',
        plugins: 'preview  importcss  directionality visualblocks visualchars fullscreen image link template codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists  wordcount  help charmap emoticons',
        mobile: {
          plugins: 'preview  casechange importcss tinydrive searchreplace autolink autosave save directionality advcode visualblocks visualchars fullscreen image link template codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists  wordcount '
            + ' help charmap quickbars emoticons',
        },
        toolbar: 'undo redo | bold italic underline strikethrough | fontfamily fontsize blocks | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist  | forecolor backcolor casechange removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl | showcomments addcomment',
        importcss_append: true,
        height: 300,
        image_caption: true,
        quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quicktable',
        noneditable_class: 'mceNonEditable',
        toolbar_mode: 'sliding',
        content_style: '.mymention{ color: gray; }',
        skin: 'oxide-dark',
        content_css: 'dark',
        file_picker_types: 'image',

        /* and here's our custom image picker */
        images_upload_base_path: '',
        file_picker_callback(cb, value, meta) {
          const input = document.createElement('input')
          input.setAttribute('type', 'file')
          input.setAttribute('accept', 'image/*')
          input.onchange = async function () {
            const file = this.files[0]
            const body = new FormData()
            body.append('image', file)
            await axios.post(`${baseConfig.baseUrl}ticket/temp/image`, body).then(r => {
              store.dispatch('temp/setTemp', r.data.data).then(() => {

              })
              cb(r.data.data, {title: file.name})
            })
            const reader = new FileReader()
            reader.readAsDataURL(file)
          }

          input.click()
        },
      },
    }
  },
  methods: {
    checkNationalCode(value) {
      let xv = value;
      if (isNaN(xv)) {
        return false
      } else if (xv === "") {
        return false
      } else if (xv.length < 10) {
        return false
      } else {
        let yy = 0;
        let yv = parseInt(yv);
        for (let i = 0; i < xv.length; i++) {
          yv = xv[i] * (xv.length - i);
          yy += yv;
        }
        let x = yy % 11;
        return x === 0;
      }
      return false
    },
    finalWay(event) {
      console.log(event)
    },
    checkValidation() {
      console.log("hujghjgbjbgjigjhj")
    },
    onPaste(evt) {
      return evt.clipboardData.getData('text')
    },
    setValidTrue(e, ref) {
      this.widget.data.valid = this.$refs[ref].validate()
      this.widget.data.valid = true
    },
    checkSubmitShouldBeActive(event, ref) {

      setTimeout(this.setValidTrue(this, ref), 200)

      /*     this.widget.data.valid =   true
           if(this.$refs[ref].validate()){
             this.widget.data.valid =   true
           }else {
             this.widget.data.valid =  true
           }*/

    },
    generateIcon(icon) {
      return eval('this.' + icon)
    },
    autoSubmit(id) {
      if (this.widget.data.autoSubmit)
        this.submit(id)
    },

    async submit(id) {
      if (this.$refs[id].validate()) {
        if (this.widget.data.hasProgressBar === true && this.status === "error") {
          this.model = "0"
          this.status = "primary"
        }

        this.widgets.map(w => w.type === 'form' && w.data.id === id ? w.data.elements.map(e => {
          if (typeof this.widget.data.field !== 'undefined')
            if (e.type === 'submit' && e.name === this.widget.data.field.name) {
              e.loading = true
            }
          if (typeof this.widget.data.field !== 'undefined')
            if (typeof this.widget.data.field.dialog !== 'undefined' && typeof this.widget.data.field.action === 'undefined') {
              e.loading = false
            }
        }) : null)
        this.widgets.map(w => w.type === 'form' && w.data.id === id ? w.data.elements.map(e => {
          if (e.type === 'text') {
            e.modelold = e.model
            e.model = "x"
            e.model = e.modelold
          }
        }) : null)

        const forms = this.widgets.filter(w => w.type === 'form' && w.data.id === id)
        const form = forms.filter(f => f.data.id === id)[0]
        console.log(form)
        let objectForDialog = []
        const body = new FormData()
        form.data.elements.map(field => (field.type !== 'submit' && field.type !== 'file' && field.type !== 'date' && field.type !== 'dropdown' && field.numberFormat !== true ? field.maskName !== '' ? field.removedStrMask === true ? body.set(field.name, removeCharFromString(field.model, field.strMask)) : body.set(field.name, field.model) : body.set(field.name, field.model) : body.set(field.name, removeCharFromString(field.model, ','))))
        form.data.elements.map(field => {
          if (field.type === 'file') {
            if (typeof field.model.length !== "undefined") {
              for (let i = 0; i < field.model.length; i++) {
                let file = field.model[i];
                body.append(field.name + '[' + i + ']', file);
              }
            } else {
              body.set(field.name + '[0]', field.model)
            }
          }
        })
        form.data.elements.map(field => (field.type === 'dropdown' && field.searchable === true ? body.set(field.name + "Text", field.model.text) : ''))
        form.data.elements.map(field => (field.type === 'dropdown' && field.searchable === true ? body.set(field.name, field.model.value) : ''))
        form.data.elements.map(field => (field.type === 'dropdown' && field.searchable === false ? body.set(field.name, field.model) : ''))
        form.data.elements.map(field => (field.type !== 'submit' && field.type !== 'date' && field.numberFormat !== true ? objectForDialog.push({
          name: field.name,
          model: field.model,
          strMask: field.strMask,
          maskName: field.maskName,
          removedStrMask: field.removedStrMask
        }) : ''))
        form.data.elements.map(field => (field.type !== 'submit' && field.type !== 'date' && field.numberFormat === true ? objectForDialog.push({
          name: field.name,
          model: removeCharFromString(field.model, ','),
          strMask: field.strMask,
          maskName: field.maskName,
          removedStrMask: field.removedStrMask
        }) : ''))
        form.data.elements.map(field => (field.type === 'date' ? body.set(field.name, moment.from(field.model, 'fa', 'YYYY/MM/DD').locale('en').format('YYYY-MM-DD')) : ''))
        form.data.elements.map(field => (field.type === 'date' ? objectForDialog.push({
          name: field.name,
          model: moment.from(field.model, 'fa', 'YYYY/MM/DD').locale('en').format('YYYY-MM-DD'),
          strMask: field.strMask,
          maskName: field.maskName,
          removedStrMask: field.removedStrMask

        }) : ''))

        body.set('updateId', form.data.updateId)
        body.set('paramId', this.paramId)
        body.set('widget', id)
        body.set('process', this.model)
        body.set('processCount', this.modelCount)
        body.set('processTotal', this.modelTotal)
        // eslint-disable-next-line no-shadow
        let storeDir = ''
        let update = '/'
        if (id.search('Filter') === -1) {
          storeDir = '/store'
          update = '/update/'
        }
        if (form.data.updateId === 0 || typeof form.data.updateId === 'undefined') {
          if (typeof form.data.action.dialog !== 'undefined' && typeof form.data.action.action === 'undefined') {
            this.$emit('open-dialog', form.data.action.dialog, objectForDialog)
          } else {
            let action
            if (typeof form.data.action.action !== 'undefined')
              action = form.data.action.action
            else
              action = form.data.action

            try {
              await axios.post(`${baseConfig.baseUrl + action}${storeDir}`, body).then(async r => {
                this.widgets.map(w => w.type === 'form' ? w.data.elements.map(e => {
                  if (e.type === 'submit') {
                    e.loading = false
                  }
                }) : null)
                if (typeof r.data.submit !== 'undefined') {
                  let inputs = ""
                  r.data.submit.fields.map(f => inputs += "<input type=\"hidden\" id='" + f.name + "' name='" + f.name + "' value='" + f.value + "'>")
                  let node = document.getElementById('node-id');
                  node.innerHTML = "<form method='post' id=\"submition\" action='" + r.data.submit.action + "'>\n" +
                    inputs +
                    "</form>"
                  setTimeout(document.forms['submition'].submit(), 1000)
                }
                if (typeof r.data.hideDialog !== 'undefined') {
                  this.$emit('close-dialog-nested', r.data.hideDialog)
                }
                if (typeof form.data.action.dialog !== 'undefined' || typeof r.data.dialog !== "undefined") {
                  let response = {
                    data: {
                      message: r.data.message,
                      status: r.data.status
                    }
                  }
                  if (r.data.status !== 'error')
                    if (typeof r.data.dialog !== 'undefined')
                      this.$emit('open-dialog', r.data.dialog, objectForDialog, form.data.action.destinationForm, r)
                    else
                      this.$emit('open-dialog', form.data.action.dialog, objectForDialog, form.data.action.destinationForm, r)
                  else
                    this.$emit('response_handler', response, false)
                  /*if (typeof r.data.dialog ==='undefined' && r.data.status!=='error')
                    this.$emit('open-dialog', r.data.dialog, objectForDialog,form.data.action.destinationForm, r)*/
                  if (typeof r.data.dialog === 'undefined')
                    this.$emit('response_handler', response, false)
                } else {
                  if (id.search('Filter') !== -1) {
                    this.filteredModelForExcel = []
                    form.data.elements.map(field => {
                      this.filteredModelForExcel.push({
                        name: field.name,
                        model: field.model,
                        strMask: field.strMask,
                        type: field.type
                      })
                    })
                    this.$emit('push-excel-data', this.filteredModelForExcel)
                    // this.widgets.map(w=> w.type === 'form' ? w.data.elements.map(e=> e.model=null) : null)
                    this.filter.id = id
                    this.filter.body = body;
                    this.filter.action = `${baseConfig.baseUrl + form.data.action}${storeDir}`;
                    let response = {
                      data: {
                        message: r.data.message,
                        status: r.data.status
                      }
                    }
                    //  this.$emit('response_handler', response, false)
                    this.$emit('filter-page', r)
                    this.$nextTick(() => {
                      //  this.widget.data.valid = true
                      if (typeof this.$refs === "object") {
                        Object.keys(this.$refs).map(k => this.$refs[k].resetValidation())
                      } else
                        Object.keys(this.$refs).map(k => this.$refs[k][0].resetValidation())
                    })

                  } else {

                    let response = {
                      data: {
                        message: r.data.message,
                        status: r.data.status
                      }
                    }
                    if (typeof r.data.data !== "undefined")
                      if (typeof r.data.data.progress !== "undefined") {
                        this.modelCount += 1
                        let howMuchAddToProgress = Math.round(((this.modelCount * r.data.data.progress.process) / r.data.data.progress.total) * 100)
                        if (this.model <= 100 && r.data.status === "success") {
                          this.model = howMuchAddToProgress

                          this.modelTotal = r.data.data.progress.total
                          this.status = "success"
                          await this.submit(id)
                        } else {
                          if (r.data.status === "error") {
                            this.status = "error"
                            this.$emit('response_handler', response, false)
                          }
                        }

                      } else if (typeof r.data.redirect !== 'undefined') {
                        //don't make fields empty
                        //this.widgets.map(w => w.type === 'form' ? w.data.elements.map(e => e.model = null) : null)
                        if (r.data.redirect !== '') {
                          store.dispatch('message/setMessage', response).then(() => {

                          })
                          let result = r.data.redirect.includes("http");
                          if (result) {
                            window.location.href = r.data.redirect
                          } else {
                            await router.push(`/${r.data.redirect}`)
                          }
                        } else {
                          let id = ""
                          if (this.paramId !== "0")
                            id = this.paramId
                          if (r.data.status === 'success') {
                            await axios.get(`${baseConfig.baseUrl + this.requestApiUrl + id}`).then(r => {
                              this.$emit('filter-page', r)
                              this.$nextTick(() => {
                                if (typeof this.$refs === "object")
                                  Object.keys(this.$refs).map(k => this.$refs[k].resetValidation())
                                else
                                  Object.keys(this.$refs).map(k => this.$refs[k][0].resetValidation())
                              })
                            })
                          }
                        }
                      } else
                        this.$emit('response_handler', response, true)

                    if (this.widget.data.hasProgressBar === false)
                      this.$emit('response_handler', response, true)
                    if (this.widget.data.hasProgressBar === true && this.model >= 100)
                      this.$emit('response_handler', response, true)

                  }
                }

                //loading things here
                this.widgets.map(w => w.type === 'form' && w.data.id === id ? w.data.elements.map(e => {
                  if (typeof this.widget.data.field !== 'undefined')
                    if (e.type === 'submit' && e.name === this.widget.data.field.name) {
                      e.loading = false
                    }
                }) : null)
                if (typeof this.widget.data.field !== 'undefined')
                  this.widgets.map(w => w.type === 'form' ? w.data.elements.map(e => {
                    if (e.type === 'text') {
                      e.modelold = e.model
                      e.model = "x"
                      e.model = e.modelold
                    }
                  }) : null)

                //end loading things
                //reset form
                this.widgets = formConfig(this.widgets)
                if (typeof this.$refs === "object") {
                  // this.widgets.map(w => (w.type === 'form' ? w.data.elements.map(e => (e.type === 'text' || e.type === 'dropdown' || e.type === 'textarea' || e.type === 'radiobutton' || e.type === 'date' || e.type === 'time' ? e.model = '' : null)) : null))
                  Object.keys(this.$refs).map(k => this.$refs[k].resetValidation())
                } else {
                  Object.keys(this.$refs).map(k => this.$refs[k][0].resetValidation())
                }
                this.widgets.map(w => w.type === 'form' ? w.data.elements.map(e => {
                  if (e.type === 'submit') {
                    e.loading = false
                  }
                }) : null)
                //end reset form
              })
            } catch (err) {
              this.widgets.map(w => w.type === 'form' && w.data.id === id ? w.data.elements.map(e => {
                if (e.type === 'submit') {
                  e.loading = false
                }
              }) : null)
              if (typeof err.response !== 'undefined') {
                if (err.response.status === 422) {
                  err.response.data.status = true
                  this.validationResponse = err.response.data
                  this.widgets.map(w => w.type === 'form' ? w.data.elements.map(e => {
                    if (e.type === 'submit') {
                      e.loading = false
                    }
                  }) : null)
                } else {
                  let response = {
                    data: {
                      message: err.message,
                      status: 'error'
                    }
                  }
                  this.$emit('response_handler', response, false)
                  //loading things here
                  this.widgets.map(w => w.type === 'form' && w.data.id === id ? w.data.elements.map(e => {
                    if (e.type === 'submit') {
                      e.loading = false
                    }
                  }) : null)
                  this.widgets.map(w => w.type === 'form' && w.data.id === id ? w.data.elements.map(e => {
                    if (e.type === 'text') {
                      e.modelold = e.model
                      e.model = "x"
                      e.model = e.modelold
                    }
                  }) : null)

                  //end loading things
                }
              } else {
                if (typeof err.message === 'undefined') {
                  let response = {
                    data: {
                      message: "خطا در پردازش درخواست ، لطفا مجدد تلاش نماييد .",
                      status: 'error'
                    }
                  }
                  this.$emit('response_handler', response, false)
                } else {
                  let response = {
                    data: {
                      message: "خطا در پردازش درخواست ، لطفا مجدد تلاش نماييد .",
                      status: 'error'
                    }
                  }
                  this.$emit('response_handler', response, false)
                }
              }


            }

          }

        } else {
          body.set('_method', 'PUT')
          await axios.post(`${baseConfig.baseUrl + form.data.action}${update}${form.data.updateId}`, body).then(async r => {
            this.widgets.map(w => w.type === 'form' && w.data.id === id ? w.data.elements.map(e => {
              if (e.type === 'submit') {
                e.loading = false
              }
            }) : null)
            let response = {
              data: {
                message: r.data.message,
                status: r.data.status
              }
            }
            if (r.data.redirect !== '') {
              store.dispatch('message/setMessage', response).then(() => {

              })
              let result = r.data.redirect.includes("http");
              if (result) {
                window.location.href = r.data.redirect
              } else {
                await router.push(`/${r.data.redirect}`)
              }
            }
            this.$emit('response_handler', response, true)
            let id = ""
            if (this.paramId !== "0")
              id = this.paramId
            await axios.get(`${baseConfig.baseUrl + this.requestApiUrl + id}`).then(r => {
              this.$emit('filter-page', r)

              this.$nextTick(() => {
                if (typeof this.$refs === "object")
                  Object.keys(this.$refs).map(k => this.$refs[k].resetValidation())
                else
                  Object.keys(this.$refs).map(k => this.$refs[k][0].resetValidation())
              })
            })
          })
        }
      } else {
        this.widget.data.elements.map(e => {
          if (e.type === 'submit') {
            e.loading = false
          }
        })

        let response = {
          data: {
            message: "لطفا ورودی ها را بررسی نمایید.",
            status: 'error'
          }
        }
        this.$emit('response_handler', response, false)
      }
    },
    async change(change, value, id) {
      this.autoSubmit(id)
      if (typeof change.submit === "string") {
        console.log(change.submit)
        if (typeof this.widget.data.oldAction === 'undefined')
          this.widget.data.oldAction = this.widget.data.action
        this.widget.data.action = change.submit
        await this.submit(id)
      }
      if ('change' in change) {
        await axios.post(baseConfig.baseUrl + change.dataFrom, {value}).then(r => {
          if (typeof change.change === 'string') {
            // eslint-disable-next-line no-return-assign
            this.widgets.map(w => (w.type === 'form' ? w.data.elements.map(e => (e.name === change.change ? e.options = r.data.data : null)) : null))
          } else {
            for (const [key, value] of Object.entries(change.change)) {


              let v = change.change.filter(c => c.field === value.field.toString())[0].destination;


              this.widgets.map(w => (w.type === 'form' ? w.data.elements.map(e => (e.name === value.field ? e.options = r.data.data[v] : null)) : null))

            }

          }

        })
      } else if ('hide' in change) {
        if (typeof change.hide === "string") {
          if ((change.condition.type === "=" && change.condition.value === value) || (change.condition.type === ">" && change.condition.value > value) || (change.condition.type === "<" && change.condition.value < value) || typeof value === 'undefined')
            this.widgets.map(w => (w.type === 'form' ? w.data.elements.map(e => (e.name === change.hide ? e.model = "By By Model Sorry for Removing you" : null)) : null))
          else
            this.widgets.map(w => (w.type === 'form' ? w.data.elements.map(e => (e.name === change.hide ? e.model = "" : null)) : null))
        } else if (typeof change.hide === "object") {
          change.hide.map(hide => {
            if ((change.condition.type === "=" && change.condition.value === value) || (change.condition.type === ">" && change.condition.value > value) || (change.condition.type === "<" && change.condition.value < value) || typeof value === 'undefined') {
              this.widgets.map(w => (w.type === 'form' ? w.data.elements.map(e => (e.name === hide ? e.modelO = e.model : null)) : null))
              this.widgets.map(w => (w.type === 'form' ? w.data.elements.map(e => (e.name === hide ? e.model = "By By Model Sorry for Removing you" : null)) : null))
              setTimeout(() => {
                //   this.widget.data.valid = true
                if (typeof this.$refs === "object") {
                  Object.keys(this.$refs).map(k => this.$refs[k].validate())
                } else
                  Object.keys(this.$refs).map(k => this.$refs[k][0].validate())
              }, 500)

            } else {
              this.widgets.map(w => (w.type === 'form' ? w.data.elements.map(e => {
                if (e.name === hide) {
                  e.model = e.modelO
                  setTimeout(() => {
                    //     this.widget.data.valid = true
                    if (typeof this.$refs === "object") {
                      Object.keys(this.$refs).map(k => this.$refs[k].validate())
                    } else
                      Object.keys(this.$refs).map(k => this.$refs[k][0].validate())
                  }, 500)
                }
              }) : null))

            }
          })
        }
      } else if ('set' in change) {
        // console.log("there is one")
      } else {
        if (change.length > 0)
          change.map(ch => {
            if (typeof ch.set !== 'undefined') {
              if ('set' in ch) {
                if (typeof ch.set === "string") {
                  if ((ch.condition.type === "=" && ch.condition.value === value) || (ch.condition.type === ">" && ch.condition.value > value) || (ch.condition.type === "<" && ch.condition.value < value))
                    this.widgets.map(w => (w.type === 'form' ? w.data.elements.map(e => {
                      if (e.name === ch.set) {
                        if (e.model !== "By By Model Sorry for Removing you")
                          if (e.numberFormat)
                            e.model = Intl.NumberFormat().format(ch.with.replaceAll(',', ''))
                          else
                            e.model = ch.with

                        this.change(e.onChange, ch.with, id)
                      }
                    }) : null))
                }
              }
            }
            if (typeof ch.hide !== 'undefined') {
              if ('hide' in ch) {
                if (typeof ch.hide === "string") {
                  this.widgets.map(w => (w.type === 'form' ? w.data.elements.map(e => (e.name === ch.hide ? e.model = "" : null)) : null))
                  let conditionValues = []
                  if (typeof ch.condition.value === "object") {
                    Object.keys(ch.condition.value).map((key) => conditionValues.push(ch.condition.value[key]));
                    if ((ch.condition.type === "=" && conditionValues.includes(value)) || typeof value === 'undefined') {
                      this.widgets.map(w => (w.type === 'form' ? w.data.elements.map(e => e.name === ch.hide ? e.model = "By By Model Sorry for Removing you" : null) : null))
                    }
                  } else {
                    if ((ch.condition.type === "=" && ch.condition.value === value) || (ch.condition.type === ">" && ch.condition.value > value) || (ch.condition.type === "<" && ch.condition.value < value) || typeof value === 'undefined') {
                      this.widgets.map(w => (w.type === 'form' ? w.data.elements.map(e => e.name === ch.hide ? e.model = "By By Model Sorry for Removing you" : null) : null))
                    }
                  }
                } else if (typeof ch.hide === "object") {
                  ch.hide.map(hide => {
                    if ((ch.condition.type === "=" && ch.condition.value === value) || (ch.condition.type === ">" && ch.condition.value > value) || (ch.condition.type === "<" && ch.condition.value < value) || typeof value === 'undefined') {
                      this.widgets.map(w => (w.type === 'form' ? w.data.elements.map(e => (e.name === hide ? e.modelO = e.model : null)) : null))
                      this.widgets.map(w => (w.type === 'form' ? w.data.elements.map(e => (e.name === hide ? e.model = "By By Model Sorry for Removing you" : null)) : null))
                      setTimeout(() => {
                        //     this.widget.data.valid = true
                        if (typeof this.$refs === "object") {
                          Object.keys(this.$refs).map(k => this.$refs[k].validate())
                        } else
                          Object.keys(this.$refs).map(k => this.$refs[k][0].validate())
                      }, 500)

                    } else {
                      this.widgets.map(w => (w.type === 'form' ? w.data.elements.map(e => {
                        if (e.name === hide) {
                          e.model = e.modelO
                          setTimeout(() => {
                            //        this.widget.data.valid = true
                            if (typeof this.$refs === "object") {
                              Object.keys(this.$refs).map(k => this.$refs[k].validate())
                            } else
                              Object.keys(this.$refs).map(k => this.$refs[k][0].validate())
                          }, 500)
                        }
                      }) : null))

                    }
                  })
                }
              }
            }
          })
      }
    },
    createImage(file) {
      const reader = new FileReader()
      reader.onload = e => {
        this.imageFormUrl = e.target.result
      }
      reader.readAsDataURL(file)
    },
    CancelUpdateFormView(tableName) {
      let response = {
        data: {
          message: "ویرایش لغو شد",
          status: "error"
        }
      }
      this.$emit('response_handler', response, true)
    },
  },
  mounted() {
    this.widgets.map(w => w.type === 'form' ? w.data.elements.map(async e => {
      let change = e.onChange
      if (typeof change !== 'undefined')
        if ('change' in change) {
          await axios.post(baseConfig.baseUrl + change.dataFrom, e.model).then(r => {
            if (typeof change.change === 'string') {
              // eslint-disable-next-line no-return-assign
              this.widgets.map(w => (w.type === 'form' ? w.data.elements.map(e => (e.name === change.change ? e.options = r.data.data : null)) : null))
            } else {
              for (const [key, value] of Object.entries(change.change)) {


                let v = change.change.filter(c => c.field === value.field.toString())[0].destination;


                this.widgets.map(w => (w.type === 'form' ? w.data.elements.map(e => (e.name === value.field ? e.options = r.data.data[v] : null)) : null))

              }

            }

          })
        } else if ('hide' in change) {
          if (typeof change.hide === "string") {
            if ((change.condition.type === "=" && change.condition.value === e.model) || (change.condition.type === ">" && change.condition.value > e.model) || (change.condition.type === "<" && change.condition.value < e.model))
              this.widgets.map(w => (w.type === 'form' ? w.data.elements.map(e => (e.name === change.hide ? e.model = "By By Model Sorry for Removing you" : null)) : null))
            else
              this.widgets.map(w => (w.type === 'form' ? w.data.elements.map(e => (e.name === change.hide ? e.model = "" : null)) : null))
          } else if (typeof change.hide === "object") {
            change.hide.map(hide => {
              if ((change.condition.type === "=" && change.condition.value === e.model) || (change.condition.type === ">" && change.condition.value > e.model) || (change.condition.type === "<" && change.condition.value < e.model)) {
                this.widgets.map(w => (w.type === 'form' ? w.data.elements.map(e => (e.name === hide ? e.modelO = e.model : null)) : null))
                this.widgets.map(w => (w.type === 'form' ? w.data.elements.map(e => (e.name === hide ? e.model = "By By Model Sorry for Removing you" : null)) : null))
                setTimeout(() => {
                  //   this.widget.data.valid = true
                  if (typeof this.$refs === "object") {
                    Object.keys(this.$refs).map(k => this.$refs[k].validate())
                  } else
                    Object.keys(this.$refs).map(k => this.$refs[k][0].validate())
                }, 500)

              } else {
                this.widgets.map(w => (w.type === 'form' ? w.data.elements.map(e => {
                  if (e.name === hide) {
                    e.model = e.modelO
                    setTimeout(() => {
                      //     this.widget.data.valid = true
                      if (typeof this.$refs === "object") {
                        Object.keys(this.$refs).map(k => this.$refs[k].validate())
                      } else
                        Object.keys(this.$refs).map(k => this.$refs[k][0].validate())
                    }, 500)
                  }
                }) : null))

              }
            })
          }
        } else if ('set' in change) {
          //  console.log("there is one")
        } else {
          if (change.length > 0)
            change.map(ch => {
              if (typeof ch.set !== 'undefined') {
                if ('set' in ch) {
                  if (typeof ch.set === "string") {
                    if ((ch.condition.type === "=" && ch.condition.value === e.model) || (ch.condition.type === ">" && ch.condition.value > e.model) || (ch.condition.type === "<" && ch.condition.value < e.model))
                      this.widgets.map(w => (w.type === 'form' ? w.data.elements.map(e => {
                        if (e.name === ch.set) {
                          if (e.model !== "By By Model Sorry for Removing you")
                            e.model = ch.with

                          this.change(e.onChange, ch.with, id)
                        }
                      }) : null))
                  }
                }
              }
              if (typeof ch.hide !== 'undefined') {
                if ('hide' in ch) {
                  if (typeof ch.hide === "string") {

                    this.widgets.map(w => (w.type === 'form' ? w.data.elements.map(e => (e.name === ch.hide ? e.model = "" : null)) : null))
                    let conditionValues = []
                    if (typeof ch.condition.value === "object") {
                      Object.keys(ch.condition.value).map((key) => conditionValues.push(ch.condition.value[key]));
                      if ((ch.condition.type === "=" && conditionValues.includes(e.model))) {
                        this.widgets.map(w => (w.type === 'form' ? w.data.elements.map(e => e.name === ch.hide ? e.model = "By By Model Sorry for Removing you" : null) : null))
                      }
                    } else {
                      if ((ch.condition.type === "=" && ch.condition.value === e.model) || (ch.condition.type === ">" && ch.condition.value > e.model) || (ch.condition.type === "<" && ch.condition.value < e.model)) {
                        this.widgets.map(w => (w.type === 'form' ? w.data.elements.map(e => e.name === ch.hide ? e.model = "By By Model Sorry for Removing you" : null) : null))
                      }
                    }
                  } else if (typeof ch.hide === "object") {
                    ch.hide.map(hide => {
                      if ((ch.condition.type === "=" && ch.condition.value === e.model) || (ch.condition.type === ">" && ch.condition.value > e.model) || (ch.condition.type === "<" && ch.condition.value < e.model)) {
                        this.widgets.map(w => (w.type === 'form' ? w.data.elements.map(e => (e.name === hide ? e.modelO = e.model : null)) : null))
                        this.widgets.map(w => (w.type === 'form' ? w.data.elements.map(e => (e.name === hide ? e.model = "By By Model Sorry for Removing you" : null)) : null))
                        setTimeout(() => {
                          //      this.widget.data.valid = true
                          if (typeof this.$refs === "object") {
                            Object.keys(this.$refs).map(k => this.$refs[k].validate())
                          } else
                            Object.keys(this.$refs).map(k => this.$refs[k][0].validate())
                        }, 500)

                      } else {
                        this.widgets.map(w => (w.type === 'form' ? w.data.elements.map(e => {
                          if (e.name === hide) {
                            e.model = e.modelO
                            setTimeout(() => {
                              //      this.widget.data.valid = true
                              if (typeof this.$refs === "object") {
                                Object.keys(this.$refs).map(k => this.$refs[k].validate())
                              } else
                                Object.keys(this.$refs).map(k => this.$refs[k][0].validate())
                            }, 500)
                          }
                        }) : null))

                      }
                    })
                  }
                }
              }
            })
        }

    }) : null)
  }
}
</script>

<style scoped>

</style>

<style>
.phoneThings input {
  direction: ltr !important;
  text-align: left !important;
}

.col-sm-0, .col-md-0, .col-lg-0, .col-xl-0 {
  display: none !important;
}

.theme--light.v-tabs.v-tabs--vertical .v-slide-group__wrapper {
  border-right: 0 !important;
}

.v-messages__message {
  font-size: 10px;
}

.v-label {
  font-size: 12px !important;
}

.v-btn.v-size--default {
  font-size: 0.73rem;
}

.theme--light.v-label--is-disabled {
  color: rgba(58, 58, 58, 0.66);
}

.theme--light.v-input--is-disabled input, .theme--light.v-input--is-disabled textarea {
  color: rgba(47, 47, 47, 0.7);
}

.v-chip-group div .v-slide-group__content {
  justify-content: right;
}

.vpd-main span input {
  width: 100%;
}

.bigChips.v-chip {
  padding: 25px 20px;
}

.yellow {
  border: 3px solid #fbc531 !important;
  background-color: #fbc531;
  color: black !important;
}

.deActiveyellow.v-chip::before {
  border: 3px solid #fbc531 !important;
  background-color: unset !important;
}

.deActiveyellow.theme--light.v-chip:not(.v-chip--active) {
  border: 3px solid #fbc531 !important;
  background-color: unset !important;
}

.LightBlue {
  border: 3px solid #2e9fff !important;
  background-color: #2e9fff;
  color: black !important;
}

.deActiveLightBlue.v-chip::before {
  border: 3px solid #2e9fff !important;
  background-color: unset !important;
}

.deActiveLightBlue.theme--light.v-chip:not(.v-chip--active) {
  border: 3px solid #2e9fff !important;
  background-color: unset !important;
}

.purple {
  border: 3px solid #9C2776 !important;
  background-color: #9C2776;
  color: white !important;
}

.deActivepurple.v-chip::before {
  border: 3px solid #9C2776 !important;
  background-color: unset !important;
}

.deActivepurple.theme--light.v-chip:not(.v-chip--active) {
  border: 3px solid #9C2776 !important;
  background-color: unset !important;
}

.theme--light.v-chip {
  color: rgba(0, 0, 0, 0.87);
}

.v-btn.v-size--default {
  font-size: 0.85rem
}

.v-label {
  font-size: 11px !important;
}
</style>
